import SectionHeading from "./SectionHeading";
import PosterCard from "./PosterCard";
import { featuredAnime } from "@/mocks/anime";

export default function Recommend() {
  const spotlight = featuredAnime[0];
  const rest = featuredAnime.slice(1);

  return (
    <section id="recommend" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <SectionHeading
        eyebrow="本季精选"
        icon="ri-fire-line"
        title="番剧推荐 · 本季值得先点开的那几部"
        description="下面这几部是从近期讨论度较高的作品中挑出的代表，覆盖恋爱、热血、仙侠、日常、科幻与悬疑。每一条都写了为什么值得看，方便你按心情直接选择。"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        {/* 主推大片位 */}
        <article className="lg:col-span-5 group relative rounded-lg overflow-hidden bg-background-950">
          <div className="relative w-full h-80 md:h-[520px] lg:h-full">
            <img
              src={spotlight.cover}
              alt={`${spotlight.title} 主推封面`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/45 to-transparent"></div>
          </div>
          <div className="absolute top-4 left-4 flex gap-2">
            <span className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
              编辑推荐
            </span>
            <span className="px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium backdrop-blur">
              {spotlight.region} · {spotlight.type}
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
            <div className="flex items-center gap-2 mb-2 text-accent-300 text-sm">
              <i className="ri-star-fill" aria-hidden="true"></i>
              <span className="font-semibold">{spotlight.rating.toFixed(1)}</span>
              <span className="text-background-300/70">·</span>
              <span className="text-background-200">{spotlight.genre}</span>
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
              {spotlight.title}
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-background-200/90 max-w-xl">
              {spotlight.summary}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {spotlight.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full bg-background-50/15 text-background-100 text-xs backdrop-blur"
                >
                  #{tag}
                </span>
              ))}
              <span className="px-2.5 py-1 rounded-full bg-background-50/15 text-background-100 text-xs backdrop-blur">
                共 {spotlight.episodes} 话
              </span>
            </div>
          </div>
        </article>

        {/* 其余推荐 */}
        <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {rest.map((item) => (
            <PosterCard
              key={item.id}
              title={item.title}
              cover={item.cover}
              rating={item.rating}
              genre={item.genre}
              region={item.region}
              type={item.type}
              episodes={item.episodes}
              badge={item.tags[0]}
              compact
            />
          ))}
        </div>
      </div>
    </section>
  );
}